import { render } from "./AssociarRequisitoAoCSU.vue?vue&type=template&id=961d89a4"
import script from "./AssociarRequisitoAoCSU.vue?vue&type=script&scoped=true&lang=js"
export * from "./AssociarRequisitoAoCSU.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__